enum CrmType {
  CentralCompany = 'CentralCompany',
  Contact = 'Contact',
  Company = 'Company',
}

export default CrmType;
